import React, { useEffect, useState } from "react";
import Dialog from "@material-ui/core/Dialog";
import t from "../../../helpers/t";
import { useSelector, paketinActions } from "inbooma-api";
import { Biscuit } from "../../../../utils";
import { $, moment } from "../../../../../vendor";
import BoxesSelect from "../behaviors/BoxesSelect";
import DatePicker from "react-datepicker";
import de from "date-fns/locale/de";
import fr from "date-fns/locale/fr";
import en from "date-fns/locale/en-GB";
import Loader from "../../../components/Loader";
import OrdersSelect from "../behaviors/OrdersSelect";

const ShowGenerateNewPinDialog = ({ handleCloseDialog, dispatch, facility, showNotification }) => {
  const language = Biscuit.get("user.lang").replace("-", "_");
  const _boxes = useSelector((state) => state.paketins_data.findFreeBoxes);
  const _setPin = useSelector((state) => state.paketins_data.generatePinForOrder);
  const [initialized, setInitialized] = useState(false);
  const [boxesPending, setBoxesPending] = useState(false);
  const [selectedBox, setSelectedBox] = useState(null);
  const [selectedOrder, setSelectedOrder] = useState([]);
  const [from, setFrom] = useState(moment(new Date()).format("YYYY-MM-DD HH:mm:ss"));
  const [to, setTo] = useState(moment(new Date()).format("YYYY-MM-DD HH:mm:ss"));
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    if (facility !== null && !initialized) {
      getBoxes();
      setInitialized(true);
    }
  }, []);

  useEffect(() => {
    if (_boxes.success === "" || boxesPending === false) {
      return;
    }
    setBoxesPending(false);
  }, [_boxes]);

  useEffect(() => {
    if (_setPin.success === "" || !submitting) {
      return;
    }
    if (_setPin.success === true) {
      showNotification("success", facility.id);
      handleCloseDialog();
    } else {
      showNotification("warning", null, t(_setPin.data.message));
    }
    setSubmitting(false);
  }, [_setPin]);

  const onChangeField = (e, name) => {
    let date, time;
    let fr = from,
      t = to;
    switch (name) {
      case "from_date_field":
        date = moment(e).format("YYYY-MM-DD");
        time = moment(from).format("HH:mm:00");
        setFrom(moment(date + " " + time).format("YYYY-MM-DD HH:mm:00"));
        fr = moment(date + " " + time).format("YYYY-MM-DD HH:mm:00");
        if (new Date(moment(date + " " + time).format("YYYY-MM-DD HH:mm:00")) > new Date(to)) {
          setTo(
            moment(new Date(moment(date + " " + time).format("YYYY-MM-DD HH:mm:00"))).format(
              "YYYY-MM-DD HH:mm:00",
            ),
          );
          t = moment(new Date(moment(date + " " + time).format("YYYY-MM-DD HH:mm:00"))).format(
            "YYYY-MM-DD HH:mm:00",
          );
        }
        break;
      case "from_time_field":
        date = moment(from).format("YYYY-MM-DD");
        time = e.target.value;
        setFrom(moment(date + " " + time).format("YYYY-MM-DD HH:mm:00"));
        fr = moment(date + " " + time).format("YYYY-MM-DD HH:mm:00");
        if (new Date(moment(date + " " + time).format("YYYY-MM-DD HH:mm:00")) > new Date(to)) {
          setTo(
            moment(new Date(moment(date + " " + time).format("YYYY-MM-DD HH:mm:00"))).format(
              "YYYY-MM-DD HH:mm:00",
            ),
          );
          t = moment(new Date(moment(date + " " + time).format("YYYY-MM-DD HH:mm:00"))).format(
            "YYYY-MM-DD HH:mm:00",
          );
        }
        break;
      case "to_date_field":
        date = moment(e).format("YYYY-MM-DD");
        time = moment(to).format("HH:mm:00");
        setTo(moment(date + " " + time).format("YYYY-MM-DD HH:mm:00"));
        t = moment(date + " " + time).format("YYYY-MM-DD HH:mm:00");
        if (new Date(moment(date + " " + time).format("YYYY-MM-DD HH:mm:00")) < new Date(from)) {
          setFrom(
            moment(new Date(moment(date + " " + time).format("YYYY-MM-DD HH:mm:00"))).format(
              "YYYY-MM-DD HH:mm:00",
            ),
          );
          fr = moment(new Date(moment(date + " " + time).format("YYYY-MM-DD HH:mm:00"))).format(
            "YYYY-MM-DD HH:mm:00",
          );
        }
        break;
      case "to_time_field":
        date = moment(to).format("YYYY-MM-DD");
        time = e.target.value;
        setTo(moment(date + " " + time).format("YYYY-MM-DD HH:mm:00"));
        t = moment(date + " " + time).format("YYYY-MM-DD HH:mm:00");
        if (new Date(moment(date + " " + time).format("YYYY-MM-DD HH:mm:00")) < new Date(from)) {
          setFrom(
            moment(new Date(moment(date + " " + time).format("YYYY-MM-DD HH:mm:00"))).format(
              "YYYY-MM-DD HH:mm:00",
            ),
          );
          fr = moment(new Date(moment(date + " " + time).format("YYYY-MM-DD HH:mm:00"))).format(
            "YYYY-MM-DD HH:mm:00",
          );
        }
        break;
    }
    $(".input-group-field").css("border-color", "rgb(227, 227, 227)");
    getBoxes(fr, t);
  };

  const getBoxes = (von = null, bis = null) => {
    dispatch(
      paketinActions.findFreeBoxes({
        token: Biscuit.get("token"),
        data: {
          facility_id: facility.id,
          client_id: Biscuit.get("user.client_id"),
          from: von === null ? from : von,
          to: bis === null ? to : bis,
        },
      }),
    );
    setBoxesPending(true);
  };
  const _showPopUp = (ev, name) => {
    let output =
      `
          <html>
            <head>
                <link href="https://fonts.googleapis.com/css?family=Open+Sans:400,600" rel="stylesheet">
                <title>` +
      t("info", null, "capital") +
      `</title>
                <style type="text/css">
                    body { font-family: "Open Sans",Helvetica,Arial,sans-serif; }
                    hode, html, table, thead { width: 100%; }
                    h4 { font-size: 18px; }
                    .printSpacer { height:100px; }
                </style>
                </head>
            <div>` +
      t(name + "_info") +
      `
            </body>
            </html>`;
    let rV = -1; // Return value assumes failure.

    if (navigator.appName == "Microsoft Internet Explorer" || navigator.appName == "Netscape") {
      var uA = navigator.userAgent;
      var rE = new RegExp("MSIE ([0-9]{1,}[\.0-9]{0,})");

      if (rE.exec(uA) != null) {
        rV = parseFloat(RegExp.$1);
      } else if (!!navigator.userAgent.match(/Trident.*rv\:11\./)) {
        rV = 11;
      }
    }

    const isChrome = /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor);
    const newWindow = window.open("", "", "height=700,width=674");

    newWindow.document.body.innerHTML = "";
    newWindow.document.body.innerHTML = output;
    if (rV >= 10 || isChrome) {
      newWindow.focus(); // necessary for IE >= 10*
    } else {
      // e.g. Firefox
      setTimeout(() => {
        newWindow.opener.focus();
      }, 0);
    }
    return true;
  };
  const onSubmit = () => {
    let errmsg = t("Please enter the following fields: ");
    let errors = [],
      errors2 = [];
    if (from === to) {
      $(".input-group-field").css("border-color", "red");
      errors2.push(t("from to", null, "capital"));
    }
    if (selectedBox === null) {
      $(".inb-c-item--select-box select").css("border-color", "red");
      errors.push(t("box", null, "capital"));
    }
    if (selectedOrder === []) {
      $("#inbooma-select-box_order input").css("border-color", "red");
      errors.push(t("order", null, "capital"));
    }
    if (errors2.length > 0) {
      showNotification(
        "warning",
        null,
        t("From and to may not have the exact same date and time."),
      );
      return;
    }
    if (errors.length > 0) {
      showNotification("warning", null, errmsg + errors.join(", "));
      return;
    }

    const postBody = {
      facility_id: facility.id,
      facility_slot_id: Number(selectedBox),
      from: from,
      to: to,
      order_id: selectedOrder.id,
    };

    dispatch(
      paketinActions.generatePinForOrder({
        token: Biscuit.get("token"),
        data: postBody,
        parameters: {
          headers: {
            "Accept-Language": language,
            "Content-Language": language,
          },
        },
      }),
    );
    setSubmitting(true);
  };

  return (
    <>
      {initialized && (
        <>
          <Dialog
            onClose={handleCloseDialog}
            aria-labelledby="changelogs-dialog-title"
            open={true}
            name="changeLogsDialog"
            id="multipleRecipientsDialog"
            maxWidth={"md"}
          >
            <header className="inb-multiple-recipients-header">
              <button
                onClick={handleCloseDialog}
                type="button"
                id="inb-multiple-recipients-dialog-close-button"
                className="button hollow secondary right button-close-multiple-recipients-dialog round"
                title={t("close generate new pin dialog")}
              >
                <i className="fi fi-x"></i>
              </button>
              <h4>{t("generate new pin", null, "capital")}</h4>

              {/* <label className="inb-form__controlLabel legendLabel"><a href="#"
                                                                        onClick={(e) => _showPopUp(e, 'voucher for temporary user')}><i
                className="inb-ico fi fi-info"> {t('info', null, 'capital')}</i></a></label>*/}
            </header>
            {/*<div id="inb-c-main-multiple-recipients" className="inb-c-listing off-canvas-content"
                     data-off-canvas-content="">
                    {!boxTrackingsPending && typeof _boxTrackings.data !== 'undefined' && _boxTrackings?.data?.length > 0 ? _boxTrackings.data.map(boxTracking => {
                        return (<>
                            <div className="inb-c-item inb-c-item--recipient row" key={boxTracking.id}>
                                <div className="medium-3 small-12 column" title={t('id', null, 'capital')}
                                     style={{minWidth: '90px'}}>
                                    <span>{moment(boxTracking.created).format('DD.MM.YY HH:mm')}</span>
                                </div>
                                <div className="medium-3 small-12 column username"
                                     title={t('recipient', null, 'capital')}
                                     style={{minWidth: '90px', cursor: 'pointer'}}>
                                    <a href={`/users/${boxTracking.user_id}?path=/facilities`}><span>{getUserNameById(boxTracking.user_id)}</span></a>
                                </div>
                                <div className="medium-6 small-12 column description"
                                     title={t('profile', null, 'capital')} style={{minWidth: '90px'}}>
                                    <span>{boxTracking.description}</span>
                                </div>
                            </div>
                        </>)
                    }): <>
                    <div
                        id="inb-app-collection-empty"
                        className="inb-announcement">
                        <div className="inb-image-box">
                            <img src="assets/img/no_data.svg"/>
                        </div>
                        <h3>
                            { t('app_msg_collection_empty') }
                        </h3>
                        <p>
                            { t('app_msg_collection_empty_body') }
                        </p>
                    </div>
                </>}*/}

            {/*</div>*/}
            <div
              id="inb-c-main-generate-pin"
              className="inb-c-listing off-canvas-content"
              data-off-canvas-content=""
            >
              <div className="inb-c-item inb-c-item--from row" key="from">
                <div className="small-6 column">
                  <div className="input-group inb-price-input-group">
                    <div className="float-left">
                      <DatePicker
                        key={"inb-form-item-" + Math.floor(Math.random() * 10000)}
                        className="input-group-field"
                        dateFormat="dd. MMMM y"
                        selected={new Date(from)}
                        onChange={(date) => onChangeField(date, "from_date_field")}
                        onKeyDown={(e) => {
                          if (e.keyCode === 8) e.preventDefault();
                        }}
                        placeholderText=""
                        locale={
                          Biscuit.get("user.lang").indexOf("de") >= 0
                            ? de
                            : Biscuit.get("user.lang").indexOf("fr") >= 0
                              ? fr
                              : en
                        }
                      />
                    </div>
                    <input
                      className="input-group-field"
                      type="time"
                      name="from_time_field"
                      value={moment(new Date(from)).format("HH:mm")}
                      style={{ maxWidth: "40%" }}
                      onChange={(e) => {
                        onChangeField(e, "from_time_field");
                      }}
                    />
                  </div>
                </div>
                <div className="small-6 column">
                  <div className="input-group inb-price-input-group">
                    <div className="float-left">
                      <DatePicker
                        key={"inb-form-item-" + Math.floor(Math.random() * 10000)}
                        className="input-group-field"
                        dateFormat="dd. MMMM y"
                        selected={new Date(to)}
                        onChange={(date) => onChangeField(date, "to_date_field")}
                        onKeyDown={(e) => {
                          if (e.keyCode === 8) e.preventDefault();
                        }}
                        placeholderText=""
                        locale={
                          Biscuit.get("user.lang").indexOf("de") >= 0
                            ? de
                            : Biscuit.get("user.lang").indexOf("fr") >= 0
                              ? fr
                              : en
                        }
                      />
                    </div>
                    <input
                      className="input-group-field"
                      type="time"
                      name="to_time_field"
                      value={moment(new Date(to)).format("HH:mm")}
                      style={{ maxWidth: "40%" }}
                      onChange={(e) => {
                        onChangeField(e, "to_time_field");
                      }}
                    />
                  </div>
                </div>
              </div>
              {!boxesPending && typeof _boxes.data !== "undefined" ? (
                <>
                  <div className="inb-c-item inb-c-item--select-box row" key="selectBox">
                    {_boxes?.data?.length > 0 ? (
                      <BoxesSelect
                        boxes={_boxes.data}
                        selectedBox={selectedBox}
                        setSelectedBox={setSelectedBox}
                      />
                    ) : (
                      <span style={{ padding: "20px", fontSize: "14px" }}>{t("no free box")}</span>
                    )}
                  </div>
                  <div className="inb-c-item inb-c-item--select-order row" key="selectOrder">
                    <OrdersSelect
                      selectedOrder={selectedOrder}
                      setSelectedOrder={setSelectedOrder}
                      dispatch={dispatch}
                      facility={facility}
                    />
                  </div>
                  <div className="inb-c-item inb-c-item-generate-pin row" key="generatePin">
                    <div className="column medium-5 small-4">&nbsp;</div>
                    <div
                      className="medium-3 small-4 column"
                      title={t("create", null, "capital")}
                      style={{ minWidth: "90px" }}
                    >
                      {_boxes?.data?.length > 0 ? (
                        <>
                          {" "}
                          <a
                            className={"button beautify beautify-" + Biscuit.get("user.client_id")}
                            href="#"
                            onClick={onSubmit}
                          >
                            <i className="fi fi-page-add"></i>
                            <span>{t("create", null, "capital")}</span>
                          </a>
                        </>
                      ) : (
                        <>
                          {" "}
                          <a
                            className={"button beautify beautify-" + Biscuit.get("user.client_id")}
                            href="#"
                            style={{ cursor: "default" }}
                          >
                            <i className="fi fi-page-add"></i>
                            {submitting ? (
                              <>
                                <span>
                                  <img
                                    alt="RollingLoader"
                                    className="rollingLoader"
                                    src={"assets/img/rolling_loader.svg"}
                                  />{" "}
                                  {t("create", null, "capital")}
                                </span>
                              </>
                            ) : (
                              <span>{t("create", null, "capital")}</span>
                            )}
                          </a>
                        </>
                      )}
                    </div>
                    <div className="column medium-4 small-4">&nbsp;</div>
                  </div>
                </>
              ) : (
                <>
                  <Loader mediumWidth={12} smallWidth={12} subLoaders={2} />
                </>
              )}
            </div>
          </Dialog>
        </>
      )}
    </>
  );
};

export default ShowGenerateNewPinDialog;
